var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M3.874.658L3.85.646A5.212 5.212 0 0 0 1.077.43L.718.502V.359A.353.353 0 0 0 .357 0 .353.353 0 0 0 0 .359V10.64c0 .203.156.359.359.359a.353.353 0 0 0 .358-.359V5.703l.502-.096a4.46 4.46 0 0 1 2.38.18l.024.011c.574.216 1.172.311 1.77.311.418 0 .836-.048 1.243-.156l.825-.203a.359.359 0 0 0 .275-.346V.944a.357.357 0 0 0-.143-.286.368.368 0 0 0-.311-.06L6.457.8A4.327 4.327 0 0 1 3.874.658zm2.762.837l.382-.096v3.718l-.561.144a4.37 4.37 0 0 1-2.595-.143l-.023-.012a5.315 5.315 0 0 0-1.77-.311c-.335 0-.67.036-1.005.096l-.358.072v-3.72l.502-.095a4.463 4.463 0 0 1 2.379.179l.024.012c.98.347 2.021.406 3.025.156z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.b0a7894948d6959d31c8ddc25ade1205.svg";
export { ForwardRef as ReactComponent };